/* eslint-disable import/no-anonymous-default-export */

import UserTypeActionTypes from "./userType.types";
import { docodeHexResponse } from "../../_common/common.utils";

const INITIAL_STATE = {
  addUserTypeDetailsResponse: null,
  updateUserTypeDetailsResponse: null,
  getUserTypeListResponse: null,
  getUserTypeListArr: [],
  fetchUserTypeDetailsResponse: null,
  fetchUserTypeDetailsArr: [],
  deleteUserTypeDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** ***************** ADD UserType DETAILS START *********************** */
    case UserTypeActionTypes.ADD_USERTYPE_DETAILS_SUCCESS:
      return { ...state, addUserTypeDetailsResponse: action.payload };

    case UserTypeActionTypes.ADD_USERTYPE_DETAILS_FAILURE:
      return { ...state, addUserTypeDetailsResponse: action.payload };

    case UserTypeActionTypes.ADD_USERTYPE_DETAILS_RESPONSE_CHANGED:
      return { ...state, addUserTypeDetailsResponse: null };
    /** ***************** ADD UserType DETAILS END *********************** */

    /** ***************** UPDATE UserType DETAILS START *********************** */
    case UserTypeActionTypes.UPDATE_USERTYPE_DETAILS_SUCCESS:
      return { ...state, updateUserTypeDetailsResponse: action.payload };

    case UserTypeActionTypes.UPDATE_USERTYPE_DETAILS_FAILURE:
      return { ...state, updateUserTypeDetailsResponse: action.payload };

    case UserTypeActionTypes.UPDATE_USERTYPE_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateUserTypeDetailsResponse: null };
    /** ***************** UPDATE UserType DETAILS END *********************** */

    /** ***************** GET UserType DETAILS START *********************** */
    case UserTypeActionTypes.GET_USERTYPE_LIST_SUCCESS:
      return {
        ...state,
        getUserTypeListResponse: action.payload,
        getUserTypeListArr: docodeHexResponse(
          action.payload,
          "GetAllUserTypePaginationKey",
        ),
      };

    case UserTypeActionTypes.GET_USERTYPE_LIST_FAILURE:
      return {
        ...state,
        getUserTypeListResponse: action.payload,
        getUserTypeListArr: [],
      };

    case UserTypeActionTypes.GET_USERTYPE_LIST_RESPONSE_CHANGED:
      return { ...state, getUserTypeListResponse: null };
    /** ***************** GET UserType DETAILS END *********************** */

    /** ***************** FETCH UserType DETAILS START *********************** */
    case UserTypeActionTypes.FETCH_USERTYPE_DETAILS_SUCCESS:
      return {
        ...state,
        fetchUserTypeDetailsResponse: action.payload,
        fetchUserTypeDetailsArr: docodeHexResponse(
          action.payload,
          "GetUserTypeKey",
        ),
      };

    case UserTypeActionTypes.FETCH_USERTYPE_DETAILS_FAILURE:
      return { ...state, fetchUserTypeDetailsResponse: action.payload };

    case UserTypeActionTypes.FETCH_USERTYPE_DETAILS_RESPONSE_CHANGED:
      return {
        ...state,
        fetchUserTypeDetailsResponse: null,
        fetchUserTypeDetailsArr: [],
      };
    /** ***************** FETCH UserType DETAILS END *********************** */

    /** ***************** DELETE UserType DETAILS START *********************** */
    case UserTypeActionTypes.DELETE_USERTYPE_DETAILS_SUCCESS:
      return { ...state, deleteUserTypeDetailsResponse: action.payload };

    case UserTypeActionTypes.DELETE_USERTYPE_DETAILS_FAILURE:
      return { ...state, deleteUserTypeDetailsResponse: action.payload };

    case UserTypeActionTypes.DELETE_USERTYPE_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteUserTypeDetailsResponse: null };
    /** ***************** DELETE UserType DETAILS END *********************** */

    default:
      return state;
  }
};
